<template>
  <div class="document-status-history i-p-10">
    <div class="title d-flex flex-row i-gap-6 i-mb-10 i-mr-12">
      <div class="text flex-column align-items-start flex-grow-1">
        <div class="name i-text-button-2 i-text-neutral-120">
          Document Status History
        </div>
        <div class="subtitle i-text-body-3 i-text-neutral-110">
          View changes to the document status
        </div>
      </div>
    </div>

    <i-spinner v-if="loadingHistory"></i-spinner>
    <div v-else-if="history.length" class="d-flex flex-column i-gap-6">
      <div
        v-for="(item, idx) in history"
        :key="idx"
        data-testid="document-status-history-item"
        class="status-history-item i-text-body-3"
      >
        <div class="status-change">
          <span v-if="item.user"
            ><strong>{{ item.user.email }}</strong> set the status to</span
          >
          <span v-else>Document Status set to</span>
          <document-status :status="item.status"></document-status>
        </div>
        <div
          class="status-time i-text-neutral-110 d-flex layout-row align-items-center"
        >
          <i-icon
            symbol="small-time-clock-circle"
            :size="12"
            class="i-text-neutral-110 i-mr-2"
          ></i-icon>
          <span class="time">{{
            formatDateTime(item.created, 'MMM D, YYYY [at] hh:mm A z')
          }}</span>
        </div>
      </div>
    </div>
    <div v-else class="no-history i-text-body-3">
      No status history available.
    </div>
  </div>
</template>
<script>
import DocumentStatus from '@/V2/documents/document-status/DocumentStatus.vue';
import { iIcon, iSpinner } from '@inscribe/signal';
import { mapActions } from 'vuex';
import { formatDateTime } from '@/utils/date';

export default {
  components: {
    DocumentStatus,
    iIcon,
    iSpinner,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingHistory: true,
      history: [],
    };
  },
  computed: {},
  watch: {
    $route() {
      this.$emit('hide-panel');
    },
  },
  mounted() {
    this.getDocumentStatusHistory({
      customerId: this.$route.params.customer_id,
      documentId: this.$route.params.document_id,
    })
      .then((resp) => {
        this.history = resp.data.data.map((item) => ({
          user: item.reviewer,
          status: item.review_status,
          created: item.created_at,
        }));
        this.history.sort((a, b) => {
          return a.created_at > b.created_at ? 1 : -1;
        });
        this.loadingHistory = false;
      })
      .catch(() => {
        this.loadingHistory = false;
      });
  },
  methods: {
    formatDateTime,
    ...mapActions(['getDocumentStatusHistory']),
  },
};
</script>
<style lang="scss" scoped>
.document-status-history-panel {
  .header-title {
    line-height: 42px;
  }

  .i-spinner {
    height: 100%;
  }

  .status-history-item {
    padding: 22px 0;

    &:not(:last-of-type) {
      border-bottom: 1px solid $light-neutral-60;
    }
  }
}
</style>
